import clsx from "clsx";
import { ChevronDown, ChevronRight, Server, RefreshCw, TestTube } from "lucide-react";
import { useDrag } from "react-dnd";

import type { Channel, Device } from "../../types";
import { ChannelNode } from "./ChannelNode";

interface Props {
  device: Device;
  channels: Channel[];
  expanded: boolean;
  onToggle: () => void;
  onSync: () => void;
  onTest: () => void;
}

export function DeviceNode({ device, channels, expanded, onToggle, onSync, onTest }: Props) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "DEVICE",
    item: {
      type: "DEVICE",
      deviceId: device.id,
      channels: channels.map((c) => c.channel_number),
    },
    collect: (m) => ({ isDragging: m.isDragging() }),
  }), [device, channels]);

  const dot = device.is_online ? "bg-green-500" : "bg-red-500";

  return (
    <div className={clsx("text-sm", isDragging && "opacity-50")}>
      <div
        ref={drag as any}
        className="flex items-center gap-1 px-2 py-1 hover:bg-line cursor-move"
      >
        <button onClick={onToggle} className="text-muted hover:text-text">
          {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>
        <Server size={14} className="text-accent" />
        <span className="flex-1 truncate" title={device.host}>{device.name}</span>
        <span className={clsx("inline-block w-2 h-2 rounded-full", dot)}
              title={device.is_online ? "Online" : "Offline"} />
        <button onClick={onSync} title="Sincronizar canales" className="text-muted hover:text-text">
          <RefreshCw size={11} />
        </button>
        <button onClick={onTest} title="Probar conexion" className="text-muted hover:text-text">
          <TestTube size={11} />
        </button>
      </div>
      {expanded && (
        <div className="ml-3 border-l border-line">
          {channels.length === 0 && (
            <p className="text-muted text-xs px-2 py-1">Sin canales (sincronizar)</p>
          )}
          {channels.map((ch) => (
            <ChannelNode key={ch.channel_number} device={device} channel={ch} />
          ))}
        </div>
      )}
    </div>
  );
}
